import cookie from 'js-cookie';

import apiClient from './api';

export const getToken = () => cookie?.get('token');
export const setToken = (token) => cookie?.set('token', token);

export const logout = () => {
    cookie?.remove("token");

    apiClient.post("api/clear-device").catch((error) => {
        console.error(error.response.data.message);
    });
}
